"use strict";

module.exports = [
    "$stateParams",
    function ($stateParams) {
        var vm = this;
        vm.statement = $stateParams.statement;
    }
];
